import { applySnapshot, getSnapshot, types } from 'mobx-state-tree';
import { SyntheticEvent } from 'react';
import { publicEnumInfoMap } from '../../lifecycle/PublicEnumInfoLifecycle';
import { INamedEntity } from '../../main/entities';
import { mg } from '../../mg/mg';
import { commSvc, IOcResponseOutputObject } from '../../services/CommSvc';
import { toasterSvc } from '../../services/ToasterSvc';
import { getOmnistore } from '../../stores/Omnistore';
import { branchDialogStore } from './BranchDialogStore';

export const TemplateDialogStore = types
	.model('TemplateDialog', {
		columnSupplierIndustry:'Supplier_Industry',
		isVisible: false,
		isPending: false,
		branchId: 0,
		supplierId: 0,
		promocode: '',
		customerNo: '',
		zipcode: '',
		usePromocode: types.maybe(types.boolean),
		supplierName:'',
		supplierEmail:'',
		industry:'',
		childStep:2
	})
	.views(self => ({
		get multirepo() {
			return getOmnistore().multirepo;
		},
		get locationStore() {
			return getOmnistore().locationStore;
		},
	}))
	.views(self => ({
		get isShowClose(){
			return !!self.multirepo.templateRepo.allAsList.length;
		},
		get isValid() {
			return self.usePromocode!==undefined
			&& !branchDialogStore.isVisible && !!self.branchId
			&& (self.usePromocode ? self.promocode.length===7 : !!self.supplierId && !!self.customerNo && !!self.zipcode);
		},
		get isValidSupplier() {
			return !!self.supplierName && !!self.supplierEmail && !!self.supplierEmail.match(/^[^@]+@[^.]+\..+$/) && !!self.customerNo;
		},
		get isEmailValid(){
			return !!self.supplierEmail.match(/^[^@]+@[^.]+\..+$/);
		},
		getValue(name: string) {
			return self[name];
		},
		get branchList() {
			return self.multirepo.branchRepo.allAsList.slice().sort(mg.comparatorOn((e: INamedEntity) => e.name));
		},
		get supplierList() {
			return self.multirepo.publicSupplierRepo.allAsList.filter(s => !s.isHidden).sort(mg.comparatorOn((e: INamedEntity) => e.name));
		},
		get supplierIndustryList() {
			return publicEnumInfoMap.get(self.columnSupplierIndustry)?.members||[];
		},
		getBranchName() {
			var currentBranchId = self.branchId || self.locationStore.branchId;
			var selectedBranch = self.multirepo.branchRepo.allAsList.slice().sort(mg.comparatorOn((e: INamedEntity) => e.name)).filter(b => b.id === currentBranchId);
			return selectedBranch[0]?.name || '';
		},
		getSupplierName(supplierId) {
			var currentSupplierId = supplierId || self.supplierId || self.locationStore.supplierId;
			if(supplierId === 123456){
				return self.supplierName;
			}
			var selectedSupplier = self.multirepo.publicSupplierRepo.allAsList.filter(s => !s.isHidden).sort(mg.comparatorOn((e: INamedEntity) => e.name)).filter(s => s.id === currentSupplierId);
			return selectedSupplier[0]?.name || '';
		}
	}))
	.actions(self => {
		let empty: any = {};
		return ({
			afterCreate() {
				empty = getSnapshot(self);
			},
			clear() {
				applySnapshot(self, empty);
			},
		});
	})
	.actions(self => ({
		applyEvent(event: SyntheticEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) {
			const t = event.target as any;
			if (t instanceof HTMLInputElement && t.type==='checkbox') {
				self[t.name] = !self[t.name];
			} else {
				self[t.name] = t.value;
			}
		},
		setUsePromocode(usePromocode: boolean | undefined) {
			self.usePromocode = usePromocode;
		},
	}))
	.actions(self => ({
		startCreateBranch() {
			self.branchId = 0;
			branchDialogStore.start();
		},
		cancelCreateBranch() {//TODO
			branchDialogStore.clear();
			self.branchId = self.locationStore.branchId;
		},
		setBranchId(branchId: number) {
			self.branchId = branchId;
		},
		setSupplierId(supplierId: number) {
			self.supplierId = supplierId;
		},
		_clearPending() {
			self.isPending = false;
			self.isVisible = true;
		},
	}))
	.actions(self => ({
		start(childStep:number) {
			self.isVisible = true;
			self.cancelCreateBranch();
			self.usePromocode = undefined;
			self.childStep = childStep;
		},
		acceptPromise(): Promise<IOcResponseOutputObject> {
			self.isPending = true;
			const param: any = {
				branchId: self.branchId,
			};
			if (self.usePromocode) {
				param.promocode = self.promocode;
			} else {
				param.supplierId = self.supplierId;
				param.customerNo = self.customerNo;
				param.zipcode = self.zipcode;
			}
			return commSvc.doPost('CreateTemplate', param)
				.then(commSvc.requireOutputObject)
				.then(r => Promise.all([self.multirepo.templateRepo.fetch('DIRECT'), self.multirepo.supplierRepo.fetch('DIRECT')]).then(() => r))
				.then(commSvc.requireOutputObject)
				.then(r => {
					const o: IOcResponseOutputObject = r.outputObject;
					self.locationStore.setBranchId(o.branchId);
					self.locationStore.setSupplierId(o.supplierId);
					self.clear();
					return r;
				})
				.catch(toasterSvc.failure)
				.finally(self._clearPending);
		},
		accept() {
			self.isPending = true;
			const param : any = {
				branchId: self.branchId,
			};
			if (self.usePromocode) {
				param.promocode = self.promocode;
			} else {
				param.supplierId = self.supplierId;
				param.customerNo = self.customerNo;
				param.zipcode = self.zipcode;
			}
			commSvc.doPost('CreateTemplate', param)
				.then(commSvc.requireOutputObject)
				.then(r => Promise.all([self.multirepo.templateRepo.fetch('DIRECT'), self.multirepo.supplierRepo.fetch('DIRECT')]).then(() => r))
				.then(commSvc.requireOutputObject)
				.then(r => {
					const o: IOcResponseOutputObject = r.outputObject;
					self.locationStore.setBranchId(o.branchId);
					self.locationStore.setSupplierId(o.supplierId);
					self.clear();
				})
				.catch(toasterSvc.failure)
				.finally(self._clearPending);
		},
		cancel() {
			self.isVisible = false;
		},
	}));
